<template>
    <el-form :model="pwdForm" :rules="pwdRules" ref="pwdElForm">
        <el-form-item class="form-item" prop="username">
            <i class="nucfont inuc-person"></i>
            <el-input type="text" id="username" v-model="pwdForm.username"
                      :placeholder="$t('app.account')"></el-input>
        </el-form-item>
        <el-form-item class="form-item" prop="password">
            <i class="nucfont inuc-password"></i>
            <el-input type="password" id="password" v-model="pwdForm.password"
                      :placeholder="$t('app.pwd')"></el-input>
        </el-form-item>
    </el-form>
</template>

<script>
    const config = require("@/config")
    import {Storage} from "@/utils"

    export default {
        data() {
            return {
                pwdForm: {
                    username: "",
                    password: "",
                },
                pwdRules: {
                    username: [
                        {required: true, message: this.$t('app.account'), trigger: "blur"}
                    ],
                    password: [
                        {required: true, message: this.$t('app.pwd'), trigger: "blur"}
                    ],
                },
            }
        },
        methods: {
            login() {
                const data = {
                    username: this.pwdForm.username.replace(/(\s*$)/g, ""),
                    password: this.pwdForm.password,
                    version: config.version
                }

                return new Promise((resolve, reject) => {
                    this.$refs['pwdElForm'].validate(valid => {
                        if (!valid) {
                            reject('表单验证未通过')
                            return
                        }
                        Storage.set("userPwd", this.pwdForm.password)
                        resolve(this.$api.login(data))
                    })
                })
            }
        },
        watch: {},
    }
</script>
